import ajax from '@assets/js/interceptor';
import util from '@assets/js/util';
const baseUrlList = '/instApply/selectDataManagement';
export default {
  namespaced: true,
  state: {
    totalCount: 0,
    dataSource: [],
    filter: {},
    disabledId: '' // 禁止选择用户的id
  },
  mutations: {
    SAVE_STATE (state, payload = {}) {
      // 由于不想全部把state给改了，所以我想把每一个数据都单独塞一下
      const keyList = Object.keys(payload);
      keyList.forEach(key => {
        state[key] = payload[key];
      });
    },
    SET_DISABLED_ID (state, disabledId) {
      state.disabledId = disabledId;
    }
  },
  actions: {
    getTableInfo ({ commit, dispatch, state }, { filter }) {
      ajax.post(`${baseUrlList}`, filter, { domainType: 'bpmApi' }).then(res => {
        const { code, data } = res.data;
        if (code == 200) {
          commit('SAVE_STATE', { dataSource: data.records, totalCount: data.total, filter });
        }
      });
    },
    submitTempGroup ({ commit }, { formData, idEdit }) {
      return new Promise(resolve => {
        // 提交
        // 通过 idEdit 判断是否是编辑的地址啥的
        console.log('formData', formData);
        resolve(true);
      });
    },
    getDetail ({ commit, dispatch, state }, { id }) {
      console.log('id', id);
    }
  }
};
